<template>
  <div>
    <v-card
      :style="[
        $vuetify.breakpoint.smAndDown
          ? { 'min-height': '100vh', 'background-color': '#f9f9f9' }
          : { 'background-color': '#f9f9f9' },
      ]"
    >
      <div style="margin-left: 10px; margin-right: 10px">
        <div
          class="pt-8"
          style="
            font-size: 20px;
            margin-left: 1rem;
            margin-right: 1rem;
            color: #444444;
          "
        >
          QR PreRegister
        </div>
        <v-card-text>
          <div>
            <v-card
              elevation="10"
              style="padding: 2%; margin-bottom: 2%; margin-top: 2%"
            >
              <v-row>
                <v-col cols="12" md="2" class="pt-5">
                  <v-menu
                    v-model="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="startDate"
                        label="Start Date"
                        append-icon="mdi-calendar-month"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        outlined
                        hide-details="auto"
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="startDate"
                      @change="menu1 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="2" class="pt-5">
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="endDate"
                        label="End Date"
                        append-icon="mdi-calendar-month"
                        outlined
                        hide-details="auto"
                        dense
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="endDate"
                      @change="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="2" lg="2" class="pt-5">
                  <v-select
                    :items="['Active', 'InActive']"
                    label="Status"
                    v-model="activeStatus"
                    required
                    clearable
                    outlined
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="2" lg="3" class="pt-5">
                  <v-text-field
                    label="Search"
                    append-icon="mdi-database-search-outline"
                    v-model="search"
                    v-on:keyup.enter="SearchPreRegister(search)"
                    clearable
                    outlined
                    dense
                  ></v-text-field>
                </v-col>

                <!-- <v-col cols="12" sm="6" md="4" lg="3" style="text-align: end">
                </v-col> -->
                <v-col cols="12" sm="12" md="4" lg="3" style="text-align: end">
                  <v-hover v-slot="{ hover }">
                    <v-btn
                      :color="'blue'"
                      class="ma-2 white--text"
                      :elevation="hover ? 10 : 2"
                      :class="{ 'on-hover': hover }"
                      @click="getPreRegisterList()"
                    >
                      Search

                      <v-icon right> mdi-magnify </v-icon>
                    </v-btn>
                  </v-hover>
                  <v-hover v-slot="{ hover }">
                    <!-- <v-btn
                      color="orange"
                      :elevation="hover ? 10 : 2"
                      class="ma-2 white--text"
                      @click="exportQRPreRegister()"
                    >
                      Export CSV
                      <v-icon right>mdi-file-chart-outline</v-icon>
                    </v-btn> -->
                    <vue-excel-xlsx
                      :data="dataExport"
                      :columns="columns"
                      :file-name="'Transaction QR PreRegister' + Date.now()"
                      :file-type="'xlsx'"
                      :sheet-name="'Transaction QR PreRegister'"
                    >
                      <v-btn color="orange" class="ma-2 white--text">
                        Export Excel
                        <v-icon right>mdi-file-excel-outline</v-icon>
                      </v-btn>
                    </vue-excel-xlsx>
                  </v-hover>
                </v-col>
              </v-row>
            </v-card>

            <v-card
              elevation="10"
              style="padding: 2%; margin-top: 2%; margin-bottom: 2%"
            >
              <v-row>
                <v-col cols="12" md="4"></v-col>
                <v-col cols="12" md="3"></v-col>
                <v-col cols="12" md="5" align="center">
                  <v-pagination
                    v-model="page"
                    :total-visible="6"
                    :length="pageCount"
                    @input="ChangePage(page)"
                  ></v-pagination>
                </v-col>
              </v-row>
              <v-data-table
                :headers="headers"
                :items="PreRegisterList"
                hide-default-footer
                style="color: #332f2fde"
                :items-per-page="itemsPerPage"
                :page.sync="page"
                single-line
                hide-details
              >
                <template v-slot:item="{ item, index }">
                  <tr>
                    <td class="header-table-css">{{ no_run + (index + 1) }}</td>
                    <!-- <td class="header-table-css">{{ item.guestInviteDocNo }}</td> -->
                    <td class="header-table-css">
                      {{ ChangeFormatDate(item.startDateTime) }}
                    </td>
                    <td class="header-table-css">
                      {{ ChangeFormatDate(item.endDateTime) }}
                    </td>
                    <td class="header-table-css">{{ item.guestInviteName }}</td>
                    <td class="header-table-css">
                      {{ item.inviteLocationName }}
                    </td>
                    <td class="header-table-css">
                      {{ item.inviteTenantName }}
                    </td>
                    <td class="header-table-css">
                      {{ item.personInviteName }}
                    </td>
                    <td class="header-table-css">
                      {{ ChangeFormatDate(item.createTime) }}
                    </td>
                    <td
                      style="
                        padding-bottom: 5px;
                        display: flex;
                        flex-direction: column-reverse;
                        align-items: center;
                      "
                    >
                      <v-btn
                        :color="GetColor(item.active)"
                        rounded
                        class="text-capitalize"
                        depressed
                        style="width: 100px"
                      >
                        <span :style="{ color: GetColorText(item.active) }">{{
                          item.active == true ? "Active" : "InActive"
                        }}</span>
                      </v-btn>
                    </td>
                    <td style="text-align: center; min-width: 150px">
                      <v-btn
                        v-if="permissionsPage.read"
                        class="mx-2"
                        fab
                        dark
                        small
                        color="orange"
                        @click="OpenPreRegisterDialog(item)"
                      >
                        <v-icon dark> mdi-eye </v-icon>
                      </v-btn>
                      <v-btn
                        v-if="permissionsPage.delete"
                        class="mx-2"
                        fab
                        dark
                        small
                        color="red"
                        @click="
                          inActivePreRegisterByPreRegisterID(
                            item.inviteID,
                            item.personIDInvite
                          )
                        "
                      >
                        <v-icon dark>mdi-cancel </v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <br />
              <v-row class="mt-5">
                <v-col cols="12" md="4"></v-col>
                <v-col cols="12" md="3">
                  <v-pagination
                    v-model="page"
                    :total-visible="20"
                    :length="pageCount"
                    @input="ChangePage(page)"
                  ></v-pagination>
                </v-col>
                <v-col cols="12" md="3"></v-col>
                <v-col cols="12" md="2">
                  <v-autocomplete
                    dense
                    solo
                    label="10/page"
                    v-model="itemsPerPage"
                    @input="ChangePerPage(itemsPerPage)"
                    :items="items"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-card-text>
      </div>
    </v-card>

    <v-dialog v-model="PreRegisterDialog" persistent max-width="800px">
      <v-card>
        <v-card-title style="background-color: black; color: white">
          <span class="text-h5">View QR PreRegister</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="3" sm="3">
                <p style="font-size: 18px">Guest Invite No :</p>
                <p style="font-size: 18px">Guest Invite Name :</p>
                <p style="font-size: 18px">Invite Location :</p>
                <p style="font-size: 18px">Invite Tenant :</p>
                <br />
                <p style="font-size: 18px">Person Invite :</p>
                <p style="font-size: 18px">Start date :</p>
                <p style="font-size: 18px">End Date :</p>
              </v-col>
              <v-col cols="12" md="9" sm="9">
                <p style="font-size: 18px; color: black">
                  {{ ViewData.guestInviteDocNo }}
                </p>
                <p style="font-size: 18px; color: black">
                  {{ ViewData.guestInviteName }}
                </p>
                <p style="font-size: 18px; color: black">
                  {{ ViewData.inviteLocationName }}
                </p>
                <p style="font-size: 18px; color: black">
                  {{ ViewData.inviteTenantName }}
                </p>
                <br />
                <p style="font-size: 18px; color: black">
                  {{ ViewData.personInviteName }}
                </p>
                <p style="font-size: 18px; color: black">
                  {{ ChangeFormatDateNoTime(ViewData.startDateTime) }}
                </p>
                <p style="font-size: 18px; color: black">
                  {{ ChangeFormatDateNoTime(ViewData.endDateTime) }}
                </p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
              style="text-align: end; margin-bottom: 20px"
            >
              <v-spacer></v-spacer>
              <v-btn
                variant="outlined"
                color="silver"
                style="min-width: 100px"
                append-icon="mdi-close-circle-outline"
                @click="PreRegisterDialog = false"
              >
                Close
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <div class="loading-box">
        <div class="inter-load">
          <div class="rect rect1"></div>
          <div class="rect rect2"></div>
          <div class="rect rect3"></div>
          <div class="rect rect4"></div>
          <div class="rect rect5"></div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { eventBus } from "../../main";
// const XLSX = require('xlsx');
// const atob = require('atob');

export default {
  name: "ManagePreRegisterTemplate",
  components: {},
  data() {
    return {
      loader: null,
      url: enurl.apiUrl,
      LoadingDialog: false,
      items: [10, 15, 20, 50, 100],
      no_run: null,
      pageCount: 0,
      page: 1,
      itemsPerPage: 10,
      AlertDialog: false,
      TypeAlert: null,
      MessageAlert: "",

      PreRegisterList: [],
      ProfileList: [],
      Conjunction: [],
      ViewData: [],
      search: "",
      activeStatus: null,
      startDate: "",
      endDate: "",
      menuStartDate: false,
      menuEndDate: false,
      PreRegisterDialog: false,
      EditStatus: false,

      // Add Edit
      PreRegisterID: 0,
      templateName: "",
      templateNameTH: "",
      templateNameEng: "",

      PreRegisterNameTH: "",
      Status: true,

      invoiceStatus: false,
      lumpSumStatus: false,
      freeStatus: false,
      periodStatus: false,
      amount: 0,
      templateTime: 0,

      templateID: 0,
      startPeriod: null,
      endPeriod: null,
      menu2: false,
      modal_startPeriod: false,
      modal_endPeriod: false,

      nameTemplateTH: "",
      nameTemplateEng: "",
      profileIDFirst: 0,
      profileIDSecond: 0,
      conjunctionID: 0,
      menu: false,
      menu1: false,
      modal: false,
      permissionsPage: [],
      dataExport: [],

      columns: [
        {
          label: "",
          field: "startDate",
        },
        {
          label: "",
          field: "endDate",
        },
        {
          label: "",
          field: "guestInviteName",
        },
        {
          label: "",
          field: "inviteLocationName",
        },
        {
          label: "",
          field: "inviteTenantName",
        },
        {
          label: "",
          field: "personInviteName",
        },
        {
          label: "",
          field: "createTime",
        },
      ],
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "No",
          sortable: false,
          align: "left",
        },
        // {
        //   text: "Guest Invite Doc No",
        //   align: "left",
        //   sortable: false,
        // },
        {
          text: "StartDate",
          align: "left",
          sortable: false,
        },
        {
          text: "EndDate",
          align: "left",
          sortable: false,
        },
        {
          text: "Guest Invite Name",
          align: "left",
          sortable: false,
        },
        {
          text: "Invite Location Name",
          align: "left",
          sortable: false,
        },
        {
          text: "Invite Tenant Name",
          align: "left",
          sortable: false,
        },
        {
          text: "Person Invite Name",
          align: "left",
          sortable: false,
        },
        {
          text: "CreateTime",
          align: "left",
          sortable: false,
        },
        {
          text: "Active",
          align: "center",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
      ];
    },
  },

  mounted() {
    let self = this;

    let Permision = localStorage.getItem("Permision");
    if (Permision == null || Permision == "") {
      this.$router.push("/Main");
    }
    let page = localStorage.getItem("page");
    this.permissionsPage = JSON.parse(Permision).find((x) => x.appName == page);

    let date = new Date();
    let currentDate = `${date.getFullYear()}-${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;
    self.startDate = currentDate;

    self.getPreRegisterList();
    self.exportQRPreRegister();
  },

  methods: {
    updateNameTemplate() {
      let that = this;
      let profileIDFirstName =
        that.profileIDFirst == 0 || that.profileIDFirst == null
          ? ""
          : that.ProfileList.find((x) => x.profileID == that.profileIDFirst)
              .profileNameTH;
      let profileIDSecondName =
        that.profileIDSecond == 0 || that.profileIDSecond == null
          ? ""
          : that.ProfileList.find((x) => x.profileID == that.profileIDSecond)
              .profileNameTH;
      let conjunctionName =
        that.conjunctionID == 0 || that.conjunctionID == null
          ? ""
          : that.Conjunction.find((x) => x.conjunctionID == that.conjunctionID)
              .conjunctionNameTH;

      let profileIDFirstNameEng =
        that.profileIDFirst == 0 || that.profileIDFirst == null
          ? ""
          : that.ProfileList.find((x) => x.profileID == that.profileIDFirst)
              .profileNameEng;
      let profileIDSecondNameEng =
        that.profileIDSecond == 0 || that.profileIDSecond == null
          ? ""
          : that.ProfileList.find((x) => x.profileID == that.profileIDSecond)
              .profileNameEng;

      let conjunctionNameEng =
        that.conjunctionID == 0 || that.conjunctionID == null
          ? ""
          : that.Conjunction.find((x) => x.conjunctionID == that.conjunctionID)
              .conjunctionNameEng;

      that.nameTemplateTH =
        profileIDFirstName + " " + conjunctionName + " " + profileIDSecondName;

      that.nameTemplateEng =
        profileIDFirstNameEng +
        " " +
        conjunctionNameEng +
        " " +
        profileIDSecondNameEng;
    },

    getPreRegisterList() {
      let self = this;
      self.LoadingDialog = true;
      self.page = 1;
      let temp = {
        page: 1,
        perpage: self.itemsPerPage,
        search: self.search == null ? "" : self.search,
        startDate: self.startDate,
        endDate: self.endDate,
        active:
          self.activeStatus == "Active"
            ? true
            : self.activeStatus == null
            ? null
            : false,
      };
      axios
        .post(`${self.url}PreRegister/getDataQRPreRegisterList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.PreRegisterList = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
            // console.log(self.PreRegisterList);
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    getPreRegisterTemplateByTemplateID() {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        templateID: self.templateID,
      };

      axios
        .post(`${self.url}PreRegister/getDataQRPreRegisterByID`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            // self.ProfileList = response.data.data;
            self.BindingEditData(response.data.data);
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },
    getMasPreRegisterProfileList() {
      let self = this;
      self.LoadingDialog = true;

      axios
        .get(`${self.url}PreRegister/getMasPreRegisterProfileList`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ProfileList = response.data.data;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    getMasConjunction() {
      let self = this;
      self.LoadingDialog = true;

      axios
        .get(`${self.url}PreRegister/getMasConjunction`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.Conjunction = response.data.data;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    ChangePage(value) {
      let self = this;
      self.LoadingDialog = true;
      self.page = value;
      let temp = {
        page: value,
        perpage: self.itemsPerPage,
        startDate: self.startDate,
        endDate: self.endDate,
        search: self.search == null ? "" : self.search,
        active:
          self.activeStatus == "Active"
            ? true
            : self.activeStatus == null
            ? null
            : false,
      };
      axios
        .post(`${self.url}PreRegister/getDataQRPreRegisterList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.PreRegisterList = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    ChangePerPage(value) {
      let self = this;
      self.LoadingDialog = true;
      self.page = 1;
      let temp = {
        page: 1,
        perpage: value,
        search: self.search == null ? "" : self.search,
        startDate: self.startDate,
        endDate: self.endDate,
        active:
          self.activeStatus == "Active"
            ? true
            : self.activeStatus == null
            ? null
            : false,
      };
      axios
        .post(`${self.url}PreRegister/getDataQRPreRegisterList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.PreRegisterList = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    SearchPreRegister(data) {
      let self = this;
      self.LoadingDialog = true;
      self.page = 1;
      let temp = {
        page: 1,
        perpage: self.itemsPerPage,
        search: data,
        startDate: self.startDate,
        endDate: self.endDate,
        active:
          self.activeStatus == "Active"
            ? true
            : self.activeStatus == null
            ? null
            : false,
      };
      axios
        .post(`${self.url}PreRegister/getDataQRPreRegisterList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.PreRegisterList = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    ChangeFormatDate(date) {
      if (!date) return null;

      var DateData = new Date(date);
      var hours = DateData.getHours();
      var minutes = DateData.getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes;
      return (
        DateData.getDate() +
        "/" +
        (DateData.getMonth() + 1) +
        "/" +
        DateData.getFullYear() +
        "  " +
        strTime
      );
    },

    checkVakidates() {
      let that = this;

      if (
        that.nameTemplateTH == "" ||
        that.nameTemplateTH == null ||
        that.nameTemplateEng == "" ||
        that.nameTemplateEng == null ||
        that.profileIDFirst == 0 ||
        that.profileIDFirst == null ||
        that.profileIDSecond == 0 ||
        that.profileIDSecond == null ||
        that.conjunctionID == 0 ||
        that.conjunctionID == null
      ) {
        return true;
      } else {
        return false;
      }
    },

    addPreRegisterTemplate() {
      let that = this;
      if (that.checkVakidates()) {
        Swal.fire({
          icon: "warning",
          title: "กรุณากรอกข้อมูลให้ครบถ้วน",
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }
      that.LoadingDialog = true;

      if (!that.EditStatus) {
        let temp = {
          nameTemplateTH: that.nameTemplateTH,
          nameTemplateEng: that.nameTemplateEng,
          profileIDFirst: that.profileIDFirst,
          profileIDSecond: that.profileIDSecond,
          conjunctionID: that.conjunctionID,
          active: that.Status,
        };
        axios
          .post(`${that.url}PreRegister/addPreRegisterTemplate`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              that.LoadingDialog = false;
              Swal.fire({
                icon: "success",
                title: "Success",
                showConfirmButton: false,
                timer: 1500,
              });
            }
            if (response.data.status == 2) {
              eventBus.$emit("logout");
            }
            that.getPreRegisterList();
            that.PreRegisterDialog = false;
          })
          .catch(function (error) {
            that.LoadingDialog = false;
            if (error.response.status != 404) {
              Swal.fire({
                icon: "error",
                title: "Error...",
                width: 900,
                text: error.response.data.message,
              });
            }
          });
      } else {
        let temp = {
          templateID: that.templateID,
          nameTemplateTH: that.nameTemplateTH,
          nameTemplateEng: that.nameTemplateEng,
          profileIDFirst: that.profileIDFirst,
          profileIDSecond: that.profileIDSecond,
          conjunctionID: that.conjunctionID,
          active: that.Status,
        };
        axios
          .post(`${that.url}PreRegister/editPreRegisterTemplate`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              that.LoadingDialog = false;
              Swal.fire({
                icon: "success",
                title: "Success",
                showConfirmButton: false,
                timer: 1500,
              });
            }
            if (response.data.status == 2) {
              eventBus.$emit("logout");
            }
            that.getPreRegisterList();
            that.PreRegisterDialog = false;
          })
          .catch(function (error) {
            that.LoadingDialog = false;
            if (error.response.status != 404) {
              Swal.fire({
                icon: "error",
                title: "Error...",
                width: 900,
                text: error.response.data.message,
              });
            }
          });
      }
    },

    GetColor(value) {
      if (value == true) {
        return "rgb(92, 184, 92,0.3)";
      } else {
        return "rgb(232, 34, 34,0.3)";
      }
    },

    GetColorText(value) {
      if (value == true) {
        return "rgb(92, 184, 92)";
      } else {
        return "rgb(232, 34, 34)";
      }
    },

    OpenPreRegisterDialog(data) {
      let self = this;
      self.PreRegisterDialog = true;
      self.ViewData = data;
    },

    BindingEditData(data) {
      let self = this;
      self.EditStatus = true;
      self.PreRegisterDialog = true;

      self.templateID = data.templateID;
      self.nameTemplateTH = data.nameTemplateTH;
      self.nameTemplateEng = data.nameTemplateEng;
      self.profileIDFirst = data.profileIDFirst;
      self.profileIDSecond = data.profileIDSecond;
      self.conjunctionID = data.conjunctionID;
      self.Status = data.active;
    },

    ChangeFormatDateNoTime(date) {
      if (!date) return null;

      var DateData = new Date(date);
      return (
        DateData.getDate() +
        "/" +
        (DateData.getMonth() + 1) +
        "/" +
        DateData.getFullYear()
      );
    },

    inActivePreRegisterByPreRegisterID(inviteID, personID) {
      let that = this;
      that.LoadingDialog = true;
      let temp = {
        inviteID: inviteID,
        personID: personID,
      };

      Swal.fire({
        title: "Cancel",
        text: "Do you want to Cancel this PreRegister ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Submit",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .post(`${that.url}PreRegister/cancelPreRegister`, temp)
            .then(function (response) {
              if (response.data.status == 0) {
                that.getPreRegisterList();
                Swal.fire("Cancel!", "Your file has been Cancel.", "success");
              }
              if (response.data.status == 2) {
                eventBus.$emit("logout");
              }
              that.LoadingDialog = false;
            })
            .catch(function (error) {
              that.LoadingDialog = false;
              if (error.response.status != 404) {
                Swal.fire({
                  icon: "error",
                  title: "Error...",
                  width: 900,
                  text: error.response.data.message,
                });
              }
            });
          that.LoadingDialog = false;
        }
        that.LoadingDialog = false;
      });
    },

    exportQRPreRegister() {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: self.search,
        startDate: self.startDate,
        endDate: self.endDate,
        active:
          self.activeStatus == "Active"
            ? true
            : self.activeStatus == null
            ? null
            : false,
      };
      axios
        .post(`${self.url}PreRegister/exportQRPreRegister`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.LoadingDialog = false;
            self.dataExport = response.data.data;
            // var tempdata = response.data.data;
            // const blob = self.base64ToBlob(tempdata, "text/csv;charset=utf-8;");
            // const linkSource = URL.createObjectURL(blob);
            // var link = document.createElement("a");
            // var date = new Date();
            // link.download =
            //   "TransactionQRPreRegisterReport_" +
            //   date.toLocaleString("th-TH") +
            //   ".csv";
            // link.href = linkSource;
            // link.click();

            // const decodedData = atob(tempdata);
            // var date = new Date();
            // const buffer = new ArrayBuffer(decodedData.length);
            // const view = new Uint8Array(buffer);
            // for (let i = 0; i < decodedData.length; i++) {
            //     view[i] = decodedData.charCodeAt(i);
            // }
            // const workbook = XLSX.read(view, { type: 'array' });
            // XLSX.writeFile(workbook, "TransactionQRPreRegisterReport_" + date.toLocaleString("th-TH") + ".xlsx");
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    base64ToBlob(base64, type = "application/octet-stream") {
      const binStr = atob(base64);
      const len = binStr.length;
      const arr = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
      }
      return new Blob([arr], { type: type });
    },
  },
};
</script>
<style scoped>
* >>> .v-data-table-header {
  background-color: black !important;
  color: #ffffff !important;
}
* >>> .v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}
.addUserTitle {
  font-size: 14px;
  font-weight: 300;
}
.input-border {
  border: 1px solid black;
  height: 35px;
  padding: 4px;
}
.validation-class {
  color: red;
  font-size: 12px;
}
.header-table-css {
  text-align: left;
  cursor: pointer;
}

*,
::before ::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  background-color: #555555;
}

.loading-box {
  width: 150px;
  height: 100px;
  border: 5px solid #f1f1f1;
  /* margin: 100px auto; */
  position: relative;
}

.inter-load {
  width: 100px;
  height: 50px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.rect {
  background: #f1f1f1;
  display: inline-block;
  height: 60px;
  width: 7px;
  margin: 0 1px;
  animation: load 1.3s infinite ease-in-out;
}

@keyframes load {
  0% {
    transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
  }
  40% {
    transform: scaleY(0.4);
  }
  100% {
    transform: scaleY(0.4);
  }
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

.rect2 {
  animation-delay: -1.2s;
}
.rect3 {
  animation-delay: -1.1s;
}
.rect4 {
  animation-delay: -1s;
}
.rect5 {
  animation-delay: -0.9s;
}
</style>
